module.exports = __webpack_public_path__ + "img/adblock.a3612548.svg";